import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'reactstrap';

import { IButtonProps } from 'types/components/buttons';
import { buildUrl, s } from 'utilities/strings';

const DashboardButton: FC<IButtonProps> = ({ replace = true, state }) => {
  const navigate = useNavigate();
  const handleClick = useCallback(
    () =>
      navigate(buildUrl('Root.children.Dashboard'), {
        replace,
        state,
      }),
    [navigate, replace, state]
  );

  return (
    <Button
      color="primary"
      onClick={handleClick}>
      {s('Site.BackToDashboard')}
    </Button>
  );
};

export default DashboardButton;
